export default {
    roles: [],
    modules: [],
    loading: true,
}
